import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {
    data: [],
    loading: false,
    error: false,
    isFulFilled: false
} 

export const fetchAddolcitoreData = createAsyncThunk(
    'newReportAddolcitore', 
    async ({ requestUrl, data }) => {
        const resp = await axios.post(requestUrl, data, {
            headers: {
                'Content-type': 'multipart/form-data',
            },                    
        })
        return resp.data
    }
)

export const getAllReports = createAsyncThunk(
    'getReportAddolcitore',
    async requestUrl => {
        const resp = await axios.get(requestUrl)
        return resp.data
    }
)

const addolcitoreSlice = createSlice({
    name: 'addolcitore',
    initialState,
    reducers: {
    },
    extraReducers: {
        [fetchAddolcitoreData.pending]: state => {
            state.loading = true
        },
        [fetchAddolcitoreData.fulfilled]: (state, { payload }) => {
            state.loading = false
            state.error = false
            state.isFulFilled = true
            state.data = payload
        },
        [fetchAddolcitoreData.rejected]: (state, { error }) => {
            state.loading = false
            state.error = error.message
        },
        [getAllReports.pending]: state => {
            state.loading = true
        },
        [getAllReports.fulfilled]: (state, { payload }) => {
            state.loading = false
            state.error = false
            state.isFulFilled = true
            state.data = payload
        },
        [getAllReports.rejected]: (state, { error }) => {
            state.loading = false
            state.error = error.message
        }
    }
})

export default addolcitoreSlice.reducer